// extracted by mini-css-extract-plugin
export default {"grand_parent":"styles_grand_parent__oNZ0j","parent":"styles_parent__OHFgl","left":"styles_left__TNE-B","right":"styles_right__BdMxO"};